import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import auth from '../middleware/auth';
import un_auth from '../middleware/un_auth';

const routes = [
  {
    //===== MAIN LAYOUT CLIENTS ====//
    path: '/pos',
    component: () => import('../layouts/PosApp.vue'),
    children: [
      {
        path: '',
        name: 'pos-inicio',
        component: () => import('../views/pos/Pos.vue'),
        meta: {
          title: "Punto de venta",
          middleware: [auth]
        }
      },
      {
        path: 'demo',
        name: 'pos-demo',
        component: () => import('../views/pos/Demo.vue'),
        meta: {
          title: "Punto de venta",
          middleware: [auth]
        }
      }
    ]
  },
  {
    path: '/',
    component: () => import('../layouts/PublicApp.vue'),
    children: [
      {
        path: '',
        redirect: {name: 'login'},
        meta: {
          middleware: [un_auth]
        }
      },
      {
        path: 'login',
        name: 'login',
        component: () => import('../views/public/Login'),
        meta: {
          title: 'Iniciar sesión',
          middleware: [un_auth]
        }
      },
    ]
  }
]

const router = new VueRouter({
  routes
})

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	// If no subsequent Middleware exists,
	// the default `next()` callback is returned.
	if (!subsequentMiddleware) return context.next;

	return (...parameters) => {
		// Run the default Vue Router `next()` callback first.
		context.next(...parameters);
		// Then run the subsequent Middleware with a new
		// `nextMiddleware()` callback.
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({ ...context, next: nextMiddleware });
	};
}

router.afterEach(() => {
  // 
})

router.beforeEach((to, from, next) => {
	if (to.meta.middleware) {
		const middleware = Array.isArray(to.meta.middleware)
			? to.meta.middleware
			: [to.meta.middleware];

		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({ ...context, next: nextMiddleware });
	}

	return next();
});

export default router
